




import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class FaFincialNumber extends Vue {
    static COMPONENT_NAME = 'fa-fincial-number'

    @Prop({type: [Number, String], default: null}) readonly value!: number | string | null
    @Prop({type: Number, default: 2}) readonly maximumFractionDigits!: number
    @Prop({type: Number, default: 0}) readonly minimumFractionDigits!: number

    get displayValue(): string {
        const normalized = this.normalizedValue

        if (normalized === null) {
            return ''
        }

        const formattedNumber = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            currencyDisplay: 'symbol',
            maximumFractionDigits: this.maximumFractionDigits,
            minimumFractionDigits: this.minimumFractionDigits,
        }).format(normalized)

        return formattedNumber.replace(/^GBP\s*/, '')
    }

    private get normalizedValue(): number | null {
        if (this.value === null || this.value === undefined || this.value === '') {
            return null
        }

        if (typeof this.value === 'number') {
            return isFinite(this.value) ? this.value : null
        }

        const numeric = Number(
            this.value
                .toString()
                .replace(/[^\d.-]/g, '')
        )

        return isFinite(numeric) ? numeric : null
    }
}
